import { BrowserRouter } from "react-router-dom";

import AppRouter from "./router/router";
import ErrorBoundary from "./utility/ErrorBoundary";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./styles/app.scss";

import config from "./config";

const App = () => (
  <ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <AppRouter config={config} />
      </Provider>
    </BrowserRouter>
  </ErrorBoundary>
);

export default App;
